import { createContext } from 'react';
export const PrivateRoutesContext = createContext(null);